import { render } from "./DashboardView.vue?vue&type=template&id=708d5152&scoped=true&ts=true"
import script from "./DashboardView.vue?vue&type=script&lang=ts"
export * from "./DashboardView.vue?vue&type=script&lang=ts"

import "./DashboardView.vue?vue&type=style&index=0&id=708d5152&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-708d5152"]])

export default __exports__